<template>
  <el-form class="tw-flex tw-items-start">
    <i-form-item
      :label="$t('common.filters.status')"
      class="tw-w-2/4 md:tw-w-1/4"
    >
      <el-select
        :model-value="filters.is_active"
        placeholder=""
        filterable
        clearable
        @change="(payload) => updateFilter('is_active', payload)"
      >
        <el-option
          :label="$t('common.fields.active')"
          :value="10"
        />
        <el-option
          :label="$t('common.fields.not_active')"
          :value="20"
        />
      </el-select>
    </i-form-item>
  </el-form>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AgencyUsersFilters',
  computed: {
    ...mapState({
      filters: (state) => state.v2.admin.cms.agency.users.filters,
    }),
  },
  methods: {
    updateFilter(field, payload) {
      this.$store.commit('v2/admin/cms/agency/users/updateFilter', { field, payload });
    },
  },
};
</script>
